import {
  IToolbarButtonDefinition,
  ToolbarButtonDefinition,
  XVIToolbarButtonDefinition,
} from '@shared/types';
import { I18n } from '@app/i18n/strings-keys';
import { BUTTON_FLEX_ORDER } from '@geniuspos/ui-shared/modules/xdm-shared-components/definitions/constants';
import { BehaviorSubject, rx } from '@app/shared/rx';
import { XVII18nService } from '@app/i18n/services';

export const BUTTON_ACTIONS = {
  EDIT: 'edit',
  VIEW: 'view',
  CREATE: 'create',
  REMOVE: 'remove',
  ADD_ITEMS: 'add_items',
  ADD_BEFORE: 'add_before',
  ADD_AFTER: 'add_after',
  MOVE_TO_TOP: 'move_to_top',
  MOVE_TO_BOTTOM: 'move_to_bottom',
  SELECT_EVENT: 'select_event',
  SELECT_SITE: 'select_site',
  PRINT_OPENING_SHEETS: 'print_opening_sheets',
  PRINT_SHEETS: 'print_sheets',
  CANCEL_OPEN_STAND_SHEET: 'cancel_opening_stand_sheet',
  SELECT_SITE_AND_EVENT: 'select_site_and_event',
  PRINT: 'print',
  EXPORT: 'export',
  AUTO_RESTOCK: 'auto_restock',
  AUTO_CLOSE: 'auto_close',
  NEXT: 'next',
  PREVIOUS: 'previous',
  RESET: 'reset',
  NEW_TEMPLATE: 'new_template',
  SAVE_LIST: 'save_list',
  EXPAND_COLLAPSE: 'expand_collapse',
};

export const BTN_OK: ToolbarButtonDefinition = {
  caption: I18n.Common.Ok,
  value: 'ok',
  class: 'pull-right btn-default',
};

export const BTN_YES: ToolbarButtonDefinition = {
  caption: I18n.Common.Yes,
  value: 'ok',
  class: 'pull-right btn-primary',
};

export const BTN_EXIT: ToolbarButtonDefinition = {
  caption: I18n.Common.Exit,
  value: 'ok',
  class: 'pull-right btn-primary',
};

export const BTN_NO: ToolbarButtonDefinition = {
  caption: I18n.Common.No,
  value: 'cancel',
  class: 'pull-right btn-default',
};

export const BTN_DONE: ToolbarButtonDefinition = {
  caption: I18n.Common.Done,
  value: 'ok',
  class: 'pull-right btn-primary',
};

export const BTN_CONTINUE: ToolbarButtonDefinition = {
  caption: I18n.Common.Continue,
  value: 'ok',
  class: 'pull-right btn-primary',
};

export const BTN_NEXT: ToolbarButtonDefinition = {
  caption: I18n.Common.Next,
  value: BUTTON_ACTIONS.NEXT,
  class: 'pull-right btn-primary',
};

export const BTN_PREVIOUS: ToolbarButtonDefinition = {
  caption: I18n.Common.Previous,
  value: BUTTON_ACTIONS.PREVIOUS,
  class: 'pull-right btn-primary',
};

export const BTN_COMPLETE: ToolbarButtonDefinition = {
  caption: I18n.Common.Complete,
  value: 'ok',
  class: 'pull-right btn-primary',
};

export const BTN_DELETE: ToolbarButtonDefinition = {
  caption: I18n.Common.Delete,
  value: 'ok',
  class: 'btn btn-danger',
};

export const BTN_CANCEL: ToolbarButtonDefinition = {
  caption: I18n.Common.Cancel,
  value: 'cancel',
  class: 'pull-right btn-default',
};

export const BTN_RESET: ToolbarButtonDefinition = {
  caption: I18n.Common.Reset,
  value: 'reset',
  class: 'pop-reset-btn pull-right btn-default',
};

export const BTN_SAVE: ToolbarButtonDefinition = {
  caption: I18n.Common.Save,
  value: 'save',
  class: 'pull-right btn-primary',
};

export const BTN_EDIT: ToolbarButtonDefinition = {
  value: BUTTON_ACTIONS.EDIT,
  caption: I18n.Common.Edit,
  class: 'btn btn-default',
  disabled: false,
  glyphicon: 'glyphicon glyphicon-pencil',
};

export const BTN_VIEW: ToolbarButtonDefinition = {
  value: BUTTON_ACTIONS.VIEW,
  caption: I18n.Common.View,
  class: 'btn btn-default',
  disabled: false,
  glyphicon: 'glyphicon glyphicon-eye-open',
};

export const BTN_REMOVE: ToolbarButtonDefinition = {
  value: BUTTON_ACTIONS.REMOVE,
  caption: I18n.Common.Remove,
  class: 'btn btn-default',
  disabled: false,
  glyphicon: 'glyphicon glyphicon-remove-sign',
};

export const BTN_CREATE: ToolbarButtonDefinition = {
  value: BUTTON_ACTIONS.CREATE,
  caption: I18n.Common.Create,
  class: 'btn btn-default',
  disabled: false,
  glyphicon: 'glyphicon glyphicon-plus-sign',
};

export const BTN_SELECT_EVENT: ToolbarButtonDefinition = {
  value: BUTTON_ACTIONS.SELECT_EVENT,
  caption: I18n.Common.SelectEvent,
  class: 'btn btn-default',
  disabled: false,
};

export const BTN_SELECT_SITE: ToolbarButtonDefinition = {
  value: BUTTON_ACTIONS.SELECT_SITE,
  caption: I18n.Forms.HawkerSessionForm.SelectSite,
  class: 'btn btn-default',
  disabled: false,
};

export const BTN_PRINT_OPENING_SHEETS: ToolbarButtonDefinition = {
  value: BUTTON_ACTIONS.PRINT_OPENING_SHEETS,
  caption: I18n.Forms.StandWorksheetForm.PrintOpeningSheets,
  class: 'btn btn-default',
  disabled: false,
};

export const BTN_PRINT_SHEET: ToolbarButtonDefinition = {
  value: BUTTON_ACTIONS.PRINT_SHEETS,
  caption: I18n.Common.PrintSheets,
  class: 'btn btn-default',
  disabled: false,
};

export const BTN_BACK: ToolbarButtonDefinition = {
  value: 'back',
  caption: I18n.Common.Back,
  class: 'pull-right btn-default',
};

export const BTN_SHOW_ALL: ToolbarButtonDefinition = {
  caption: I18n.Common.ShowAll,
  class: 'btn btn-link',
};

export const BTN_COLLAPSE: ToolbarButtonDefinition = {
  caption: I18n.Common.Collapse,
  class: 'btn btn-link',
};

export const GRID_CREATE_BTN: ToolbarButtonDefinition = {
  value: 'create',
  caption: I18n.Common.Create,
  flexOrder: BUTTON_FLEX_ORDER.RIGHTMOST,
  class: 'btn-primary',
};

export const GRID_EDIT_BTN: ToolbarButtonDefinition = {
  value: BUTTON_ACTIONS.EDIT,
  caption: I18n.Common.Edit,
};

export const GRID_REMOVE_BTN: ToolbarButtonDefinition = {
  value: 'remove',
  caption: I18n.Common.Remove,
};

export const GRID_INSERT_BEFORE: ToolbarButtonDefinition = {
  value: 'add_before',
  caption: I18n.Common.AddBefore,
};

export const GRID_INSERT_AFTER: ToolbarButtonDefinition = {
  value: 'add_after',
  caption: I18n.Common.AddAfter,
};

export const GRID_MOVE_TO_TOP: ToolbarButtonDefinition = {
  value: 'move_to_top',
  caption: I18n.Common.MoveToTop,
};

export const GRID_MOVE_TO_BOTTOM: ToolbarButtonDefinition = {
  value: 'move_to_bottom',
  caption: I18n.Common.MoveToBottom,
};

export const BTN_VIEW_DETAILS: ToolbarButtonDefinition = {
  value: 'view-details',
  caption: I18n.Common.ViewDetails,
  class: 'btn btn-default',
  disabled: false,
};

export const BTN_SHOW_DELETED_ITEMS: ToolbarButtonDefinition = {
  value: 'Deleted Items View',
  caption: I18n.Common.DeletedItemsListView,
  hidden: true,
};

export const BTN_ADD_ITEMS: ToolbarButtonDefinition = {
  flexOrder: BUTTON_FLEX_ORDER.RIGHTMOST,
  caption: I18n.Common.AddItems,
  class: 'btn-primary',
};

export const ACTIONS_PANEL_BUTTON: ToolbarButtonDefinition = {
  flexOrder: BUTTON_FLEX_ORDER.LEFTMOST,
  caption: I18n.Common.Actions,
  value: 'actions',
  childItems: [],
};

export const BUTTON_SEPARATOR: ToolbarButtonDefinition = {
  value: 'separator',
  class: 'after-last-item',
};

export const BUTTON_MAKE_DEFAULT: ToolbarButtonDefinition = {
  value: 'make_default',
  caption: I18n.Common.MakeDefault,
};

export const BTN_REFRESH: ToolbarButtonDefinition = {
  value: 'refresh',
  caption: I18n.Common.Refresh,
};

export const BTN_CANCEL_OPEN_STAND_WORKSHEET: ToolbarButtonDefinition = {
  value: BUTTON_ACTIONS.CANCEL_OPEN_STAND_SHEET,
  caption: I18n.Forms.StandWorksheetForm.CancelOpenStandWorksheets,
  disabled: false,
};

export const BTN_SELECT_SITE_AND_EVENT: ToolbarButtonDefinition = {
  value: BUTTON_ACTIONS.SELECT_SITE_AND_EVENT,
  caption: I18n.Common.SelectSiteAndEvent,
  class: 'btn btn-default',
  disabled: false,
};

export const BTN_PRINT: ToolbarButtonDefinition = {
  value: BUTTON_ACTIONS.PRINT,
  caption: I18n.Common.Print,
  class: 'btn btn-default',
  disabled: false,
};

export const BTN_EXPORT: ToolbarButtonDefinition = {
  value: BUTTON_ACTIONS.EXPORT,
  caption: I18n.Common.ExportPDF,
  class: 'btn btn-default',
  disabled: false,
};

export const BTN_AUTO_RESTOCKS: ToolbarButtonDefinition = {
  value: BUTTON_ACTIONS.AUTO_RESTOCK,
  caption: I18n.Common.AutoRestock,
  class: 'btn btn-default',
  disabled: false,
};

export const BTN_CLOSE: ToolbarButtonDefinition = {
  caption: I18n.Common.Close,
  value: 'close',
  class: 'pull-right btn-default',
};

export const BTN_ADD_SITES: ToolbarButtonDefinition = {
  caption: I18n.Common.AddSitesBrackets,
  class: 'btn-primary button-right-padding-20',
};

export const BTN_SAVE_LIST: XVIToolbarButtonDefinition = {
  value: BUTTON_ACTIONS.SAVE_LIST,
  caption: I18n.Common.SaveChanges,
  class: 'btn btn-default btn-primary',
  disabled: false,
  glyphicon: 'glyphicon glyphicon-plus-sign',
};

export const BTN_DISCARD_CHANGES: XVIToolbarButtonDefinition = {
  value: 'discard_changes',
  caption: I18n.Common.DiscardAllUnsavedChanges,
  class: 'btn btn-default',
};

export const BTN_SELECT_EVENT_AND_SITE: ToolbarButtonDefinition = {
  value: BUTTON_ACTIONS.SELECT_SITE_AND_EVENT,
  caption: I18n.Common.SelectEventAndSite,
  class: 'btn btn-default',
};

export const getExpandOrCollapseBtn = (params: {
  isGridCollapsed$: BehaviorSubject<boolean>;
  i18nService: XVII18nService;
}): IToolbarButtonDefinition => ({
  captionObs: params.isGridCollapsed$.pipe(
    rx.map((isCollapsed) => {
      return params.i18nService.t(I18n.Forms.GridForm.isExpandAllProducts, {
        isExpand: params.i18nService.t(
          isCollapsed ? I18n.Common.Expand : I18n.Common.Collapse,
        ),
      });
    }),
  ),
  value: BUTTON_ACTIONS.EXPAND_COLLAPSE,
  flexOrder: BUTTON_FLEX_ORDER.LEFT,
  isFlattenButtonToActionPanel: true,
});
